/**
 * 静态资源 URL（public 目录）
 */
export function getAssetBase(): string {
  if (typeof window === 'undefined') {
    return '/';
  }

  const baseTag = document.querySelector('base')?.getAttribute('href');
  if (baseTag) {
    return baseTag.endsWith('/') ? baseTag : `${baseTag}/`;
  }

  return '/';
}

export function assetUrl(path: string): string {
  const normalized = path.replace(/^\//, '');
  const base = getAssetBase();
  return `${base}${normalized}`;
}

/** public/icons 下静态图，构建后位于站点 /icons/ */
export function iconPublicUrl(file: string): string {
  const name = file.replace(/^\/?icons\//, '');
  return `/icons/${name}`;
}

/** 分享页、外链填写页不加载全站背景图 */
export function isSharePagePath(pathname?: string): boolean {
  const path = pathname ?? (typeof window !== 'undefined' ? window.location.pathname : '');
  return (
    path === '/share' ||
    path.startsWith('/share/') ||
    path === '/asset-fill' ||
    path.startsWith('/asset-fill/')
  );
}

export function clearShareBackgroundAssets(): void {
  if (typeof document === 'undefined') return;
  document.documentElement.classList.add('geo-share-page');
  document.documentElement.style.setProperty('--geo-web-bg', 'none');
  if (document.body) {
    document.body.classList.add('geo-share-page');
  }
}

/** 同步全站背景图 CSS 变量（供 global.less 使用，固定 /icons/web_pic.png） */
export function syncGlobalBackgroundAssets(): void {
  if (typeof document === 'undefined') return;
  if (isSharePagePath()) {
    clearShareBackgroundAssets();
    return;
  }
  document.documentElement.classList.remove('geo-share-page');
  if (document.body) {
    document.body.classList.remove('geo-share-page');
  }
  document.documentElement.style.setProperty(
    '--geo-web-bg',
    `url("${iconPublicUrl('web_pic.png')}")`,
  );
}
